"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var entities;
(function (entities) {
    var EntityType;
    (function (EntityType) {
        EntityType[EntityType["Event"] = 0] = "Event";
        EntityType[EntityType["Market"] = 1] = "Market";
        EntityType[EntityType["League"] = 2] = "League";
        EntityType[EntityType["Sport"] = 3] = "Sport";
        EntityType[EntityType["Region"] = 4] = "Region";
    })(EntityType = entities.EntityType || (entities.EntityType = {}));
    var SelectionSide;
    (function (SelectionSide) {
        SelectionSide[SelectionSide["Home"] = 1] = "Home";
        SelectionSide[SelectionSide["Draw"] = 2] = "Draw";
        SelectionSide[SelectionSide["Away"] = 3] = "Away";
    })(SelectionSide = entities.SelectionSide || (entities.SelectionSide = {}));
    var OutcomeType;
    (function (OutcomeType) {
        OutcomeType["Home"] = "Home";
        OutcomeType["Tie"] = "Tie";
        OutcomeType["Draw"] = "Draw";
        OutcomeType["Away"] = "Away";
        OutcomeType["OneOrX"] = "1X";
        OutcomeType["XOrTwo"] = "X2";
        OutcomeType["OneTwo"] = "12";
        OutcomeType["Over"] = "Over";
        OutcomeType["Exactly"] = "Exactly";
        OutcomeType["Under"] = "Under";
        OutcomeType["Yes"] = "Yes";
        OutcomeType["No"] = "No";
        OutcomeType["Odd"] = "Odd";
        OutcomeType["Even"] = "Even";
        OutcomeType["ToScoreFirst"] = "ToScoreFirst";
        OutcomeType["ToScoreLast"] = "ToScoreLast";
        OutcomeType["ToScoreAnyTime"] = "ToScoreAnyTime";
        OutcomeType["ToScoreFirstOrLast"] = "ToScoreFirstOrLast";
        OutcomeType["ToScore2OrMore"] = "ToScore2OrMore";
        OutcomeType["ToScore3OrMore"] = "ToScore3OrMore";
    })(OutcomeType = entities.OutcomeType || (entities.OutcomeType = {}));
    var GamePart;
    (function (GamePart) {
        GamePart["FirstOvertime"] = "FirstOvertime";
        GamePart["BreakAfterFirstOvertime"] = "BreakAfterFirstOvertime";
        GamePart["SecondOvertime"] = "SecondOvertime";
        GamePart["FirstSet"] = "FirstSet";
        GamePart["SecondSet"] = "SecondSet";
        GamePart["ThirdSet"] = "ThirdSet";
        GamePart["FourthSet"] = "FourthSet";
        GamePart["FifthSet"] = "FifthSet";
        GamePart["FirstPeriod"] = "FirstPeriod";
        GamePart["BreakAfterFirstPeriod"] = "BreakAfterFirstPeriod";
        GamePart["SecondPeriod"] = "SecondPeriod";
        GamePart["BreakAfterSecondPeriod"] = "BreakAfterSecondPeriod";
        GamePart["ThirdPeriod"] = "ThirdPeriod";
        GamePart["BreakAfterThirdPeriod"] = "BreakAfterThirdPeriod";
        GamePart["FirstQuarter"] = "FirstQuarter";
        GamePart["BreakAfterFirstQuarter"] = "BreakAfterFirstQuarter";
        GamePart["SecondQuarter"] = "SecondQuarter";
        GamePart["BreakAfterSecondQuarter"] = "BreakAfterSecondQuarter";
        GamePart["ThirdQuarter"] = "ThirdQuarter";
        GamePart["BreakAfterThirdQuarter"] = "BreakAfterThirdQuarter";
        GamePart["FourthQuarter"] = "FourthQuarter";
        GamePart["BreakAfterFourthQuarter"] = "BreakAfterFourthQuarter";
        GamePart["Overtime"] = "Overtime";
        GamePart["FirstHalf"] = "FirstHalf";
        GamePart["SecondHalf"] = "SecondHalf";
        GamePart["BreakAfterFirstHalf"] = "BreakAfterFirstHalf";
    })(GamePart = entities.GamePart || (entities.GamePart = {}));
    var GameStatus;
    (function (GameStatus) {
        GameStatus["NotStarted"] = "NotStarted";
        GameStatus["InProgress"] = "InProgress";
    })(GameStatus = entities.GameStatus || (entities.GameStatus = {}));
    var ClockDirection;
    (function (ClockDirection) {
        ClockDirection["Stopwatch"] = "Stopwatch";
        ClockDirection["Timer"] = "Timer";
    })(ClockDirection = entities.ClockDirection || (entities.ClockDirection = {}));
})(entities = exports.entities || (exports.entities = {}));
//# sourceMappingURL=entities.js.map